import { FC } from 'react';

import { IcMyLocationIcon } from '@gem/icons';

import styles from './CenterPinButton.styles.m.css';

interface ICenterPinButtonProps {
  centerPin(): void;
}

export const CenterPinButton: FC<ICenterPinButtonProps> = ({ centerPin }) => {
  return (
    <button
      type="button"
      className={styles.container}
      onClick={centerPin}
    >
      <IcMyLocationIcon />
    </button>
  );
};
